import { downloadAsImage } from 'components/Shared/MoreVertActions/utility/DownloadImage'
import { downloadAsPdf } from 'components/Shared/MoreVertActions/utility/DownloadPdf'
import { downloadTableAsPdf } from 'components/Shared/MoreVertActions/utility/DownloadTableAsPdf'
import { downloadCSV } from 'components/Shared/MoreVertActions/utility/DownloadAsCsv'

export const MoreVertOptions: any = (t: any) => {
  return {
    jpeg: {
      label: t(`common.morevert.jpeg`),
      action: downloadAsImage,
    },
    png: {
      label: t(`common.morevert.png`),
      action: downloadAsImage,
    },
    pdf: {
      label: t(`common.morevert.pdf`),
      action: downloadAsPdf,
    },
    table_pdf: {
      label: t(`common.morevert.pdf`),
      action: downloadTableAsPdf,
    },
    csv: {
      label: t(`common.morevert.csv`),
      action: downloadCSV,
    },
  }
}
